import { __assign } from '../../_virtual/_tslib.js';
import { css } from '@emotion/css';

var isVlaidClass = function (s) { return s && typeof s === "string"; };
var filterValidClasses = function (classes) {
    return classes.filter(isVlaidClass);
};
var classNames = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return filterValidClasses(classes).join(" ").trim();
};
var EXLY_REACT_LIB_CLASSNAME_PREFIX = "--ERL"; // keep it same as the `prefix` in `postcss.config.js`
var getStylesObjFromCss = function (_a) {
    var styles = _a.styles, componentName = _a.componentName;
    var classNamesObj = {};
    Object.keys(styles).forEach(function (k) {
        classNamesObj[k] = css(__assign(__assign({}, styles[k]), { label: "".concat(k).concat(componentName ? "--" + componentName : "").concat(EXLY_REACT_LIB_CLASSNAME_PREFIX) }));
    });
    return classNamesObj;
};

export { classNames, getStylesObjFromCss };
//# sourceMappingURL=styling.js.map
